"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class VerticalLayout2Module {
}
exports.VerticalLayout2Module = VerticalLayout2Module;
